import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography, Button } from '@mui/material';
import { ReactComponent as HandPointingIcon } from '../assets/icons/HandPointing.svg';
import SearchSettingsPage from '../assets/screenshots/SearchSettingsPageBlurWithRed.svg'
// import CloseIcon from '@mui/icons-material/Close';
import SearchPageWithoutLabel from '../assets/screenshots/SearchSettingsPage.svg'
// import Logo from '../assets/icons/tennavi_scout_logo2026_4.png';
import ModalWrapper from './ModalWrapper';

export default function CompanyStepOneRegistrationGuard({ open, onClose, onConfirm, onCompanyInfoClick, onJobInfoClick }) {
  const [imgLoaded, setImgLoaded] = useState(false);

  useEffect(() => {
    if (open) {
      const img = new window.Image();
      img.src = SearchPageWithoutLabel;
      img.onload = () => setImgLoaded(true);
    } else {
      setImgLoaded(false);
    }
  }, [open]);

  const handleClose = () => {
    localStorage.removeItem('first_login'); // Remove first_login from local storage
    onClose && onClose();
  };

  // Block opening if register_expired is '1'
  const shouldOpen = open && imgLoaded && localStorage.getItem('register_expired') !== '1';
  return (
    <ModalWrapper open={shouldOpen} onClose={handleClose} smWidth={600} ariaLabel="searchsettings-guard-title" ariaDesc="searchsettings-guard-desc">
      <Box
        sx={{
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: { xs: 3, sm: 4 },
          textAlign: 'center',
          position: 'relative',
        }}
      >
        {/* Close (X) */}
        {/* <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', top: 8, right: 8, color: (t) => t.palette.grey[700] }}
        >
          <CloseIcon />
        </IconButton> */}

        <Stack spacing={2.5} alignItems="center">
          {/* Logo */}
          {/* <Box aria-hidden>
            <img src={Logo} alt="Logo" style={{ width: 100 }} />
          </Box> */}

          {/* Title */}
          <Typography
            id="searchsettings-guard-title"
            component="h2"
            sx={{
              fontFamily: '"Noto Sans JP", sans-serif',
              fontWeight: 700,
              fontSize: { xs: 22, sm: 28 },
              color: '#000',
              letterSpacing: 0.5,
              lineHeight: 1.35,
            }}
          >
            気になる人材を探してみましょう！​
            {/* Welcome to Tennavi Accounting */}
          </Typography>

          
          <Box sx={{ position: 'relative', width: 570, marginTop: 2 }}>
            {/* Animated icon and label overlay */}
            <Box
              sx={{
                position: 'absolute',
                top: -15,
                left: 30,
                zIndex: 2,
                p: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'none',
              }}
            >
              <Box
                sx={{
                  animation: 'arrowBounce 1s infinite',
                  '@keyframes arrowBounce': {
                    '0%, 100%': { transform: 'translateY(0)' },
                    '50%': { transform: 'translateY(-12px)' },
                  },
                }}
              >
                <HandPointingIcon
                  sx={{
                    fontSize: 42,
                    color: '#ed3221ff',
                    transform: 'rotate(180deg)',
                  }}
                />
              </Box>
            </Box>
            <img src={SearchSettingsPage} alt="Logo" style={{ width: 570, marginTop:0 }} onLoad={() => setImgLoaded(true)} />
          </Box>

          {/* CTA (exact label as image) */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'center', // centers horizontally
          }}>
              <Button
                variant="contained"
                onClick={onConfirm}
                className="yellowButton"
                sx={{
                  mt: 1,
                  width: { xs: '100%', sm: 110 },
                  height: 33,
                  fontWeight: 500,
                  fontSize: { xs: 14, sm: 16 },
                }}
              >
                OK
              </Button>
            </Box>
        </Stack>
      </Box>
    </ModalWrapper>
  );
}

CompanyStepOneRegistrationGuard.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCompanyInfoClick: PropTypes.func,
  onJobInfoClick: PropTypes.func,
};